import { useAppSelector } from 'state/hooks'
import { AppState } from 'state'

export function useSelectNotifications() {
  return useAppSelector((state: AppState) => state.notifications)
}
